import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import AppSideScroll from './AppSideScroll';
import { spacing } from '../../lib/theme';
import Podcast from '../Podcast/Podcast';
import AppAlertDiv from './AppAlertDiv';

class HomeRecommendations extends Component {
    render() {
        const { homeRecommendations, userDetails } = this.props;
        console.dir(homeRecommendations);
        if (userDetails && userDetails.uid) {
            if (!homeRecommendations || homeRecommendations.length < 1) {
                return (<></>)
            }
        }
        return (
            <div style={{ marginBottom: '16px' }}>
                <AppSideScroll title={'Recommended For You'}>
                    {
                        (!userDetails || !userDetails.uid) ? <div style={{ width: '100vw', marginBottom: '48px' }}>
                            <AppAlertDiv message={`Your book recommendations will show up here.`} showIcon />

                        </div> : (homeRecommendations).map((podcast, index) =>
                            <div key={index} style={{ marginRight: `${spacing('lg')}` }}>
                                <Podcast className='cards' podcast={podcast} showSubscribe={true} size='lg' />
                            </div>
                        )
                    }
                </AppSideScroll>
            </div>
        )
    }
}

HomeRecommendations.propTypes = {
    forYouEpisodes: PropTypes.object,
    homeRecommendations: PropTypes.array,
    userDetails: PropTypes.object,
    // showMore: PropTypes.bool,
    getBrowsePodcasts: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        // forYouEpisodes: state.forYouEpisodes,
        // dbPodcastState: state.dbPodcastState,
        userDetails: state.userDetails,
        homeRecommendations: state.homeRecommendations,
        // userPlaylists: state.userPlaylists,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // getBrowsePodcasts: bindActionCreators(getBrowsePodcasts, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeRecommendations);
